import React, { Component } from 'react';
import { TextInput, Text, View, StyleSheet, Dimensions, Platform } from 'react-native';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

const InputContainer = React.forwardRef((props, ref) => {
  const { placeholder, placeHolderTextStyle, value, onChangeText,
    textInputStyle, inputContainerStyle, error, onSubmitEditing, autoFocus = false } = props;
  return (
    <View style={[styles.inputWidth]}>
      <View style={[styles.inputContainer, inputContainerStyle]}>
      <View style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
        <TextInput
          onSubmitEditing={onSubmitEditing}
          style={[styles.inputMargin, styles.textStyle, { flex: 1}, textInputStyle]}
          placeholder={placeholder}
          ref={ref}
          autoFocus={autoFocus}
          keyboardType='number-pad'
          placeholderTextColor={placeHolderTextStyle ? placeHolderTextStyle : Theme.GREY_MEDIUM}
          value={value}
          onChangeText={onChangeText}
          disableFullscreenUI={true}
        ></TextInput>
        {<Text style={[{ marginRight: defaultScale(15), color: Theme.GREY_MEDIUM },
          styles.textStyle, textInputStyle]}>*</Text>}
      </View>
      </View>
    </View>
  );
});

const PlaceHolder = ({ placeholder, placeHolderTextStyle, inputContainerStyle}) => {
  return (
    <View style={[styles.placeholder, styles.inputContainer, inputContainerStyle]}>
      <TextInput
        style={[styles.placeholderMargin, styles.textStyle]}
        placeholder={placeholder}
        editable={false}
        placeholderTextColor={placeHolderTextStyle ? placeHolderTextStyle : Theme.GREY_MEDIUM}
      />
    </View>
  );
};

class ImperialHeightInput extends Component {
  constructor(props) {
    super(props);
    const {input: {value}} = this.props;
    if (value) {
      const parsedHeightValue = JSON.parse(this.props.input.value);
      this.state = {
        inches: parsedHeightValue.inches,
        feet : parsedHeightValue.feet,
      };
    } else {
      this.state = {
        inches: '',
        feet: '',
      };
    }
    this.inchesInputRef = React.createRef();

  }
  shouldShowLabel = (showLabel) => {
  if (Platform.OS === 'web' && isMobile === false && showLabel) {
      return true;
    } else {
      return (this.state.inches !== '' || this.state.feet !== '') && showLabel;
    }
  }
  showError(error, touched) {
    return error && error !== 'Required' || error && touched;
  }
convertFeetAndInchesToFeet(onChange, inches, feet) {
    if (!inches) {
      inches = null;
    }
    if (!feet) {
      feet =  null;
    }
    onChange(JSON.stringify({inches, feet}));
  }

render() {
    const {
      input: { onChange, value, ...restInput },
      meta: { touched, error } = {},
      textInputStyle,
      inputContainerStyle,
      placeHolderTextStyle,
      errorTextStyle,
      labelStyle,
      showLabel,
      t,
      autoFocus,
      onSubmitEditing,
    } = this.props;

    return (<>
    {this.shouldShowLabel(showLabel) && <Text style={[styles.labelText, labelStyle]}>Height</Text>}
      <View style={styles.mainContainer}>
      <View style={styles.secondaryContainer}>
        <InputContainer
          placeholder={t('Feet')}
          onSubmitEditing={onSubmitEditing}
          autoFocus={autoFocus}
          value={this.state.feet}
          placeHolderTextStyle={placeHolderTextStyle}
          touched={touched}
          error={error}
          textInputStyle={textInputStyle}
          inputContainerStyle={inputContainerStyle}
          onChangeText={(feet) => {
            if (feet !== '') {
              this.inchesInputRef.current.focus();
            }
            this.setState({ feet });
            this.convertFeetAndInchesToFeet(
              onChange,
              this.state.inches,
              feet,
            );
          }}
        />
        <PlaceHolder
          placeholder={t('ft')}
          placeHolderTextStyle={placeHolderTextStyle}
          textInputStyle={placeHolderTextStyle}
          inputContainerStyle={inputContainerStyle}
        />
      </View>
      <View style={[{ marginLeft: '2%' }, styles.secondaryContainer]}>
        <InputContainer
          onSubmitEditing={onSubmitEditing}
          placeholder={t('Inches')}
          ref={this.inchesInputRef}
          placeHolderTextStyle={placeHolderTextStyle}
          value={this.state.inches}
          touched={touched}
          error={error}
          textInputStyle={textInputStyle}
          inputContainerStyle={inputContainerStyle}
          onChangeText={(inches) => {
            this.setState({ inches });
            this.convertFeetAndInchesToFeet(
              onChange,
              inches,
              this.state.feet,
            );
          }}
        />
        <PlaceHolder
          placeholder={t('in')}
          placeHolderTextStyle={placeHolderTextStyle}
          textInputStyle={placeHolderTextStyle}
          inputContainerStyle={inputContainerStyle}
        />
      </View>
    </View>
    { this.showError(error, touched) ? <Text style={[styles.error, errorTextStyle]}>{error}</Text> : null}

  </>);
  }
}
const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: 'row',
    width: '100%',
    marginVertical: defaultScale(5),
  },
  secondaryContainer: {
    flexDirection: 'row',
    width: '49%',
  },
  inputContainer: {
    backgroundColor: Theme.GREY_LIGHT,
    height: defaultScale(40),
    borderRadius: defaultScale(3),
    justifyContent: 'center',
  },
  inputWidth: {
    width: '80%',
  },
  placeholder: {
    width: '18%',
    marginLeft: '2%',
  },
  textStyle: {
    ...Theme.textStyle.bodyCopyReg,
  },
  placeholderMargin: {
    marginLeft: defaultScale(5),
  },
  inputMargin: {
    marginLeft: defaultScale(15),
  },
  error: {
    ...Theme.textStyle.small,
    color: Theme.RED,
  },
  labelText: {
    ...Theme.textStyle.small,
    color: Theme.GREY,
  },
});

export default translate(['formFields'], { wait: true })(ImperialHeightInput);
